import React from "react";
import { FaEdit } from "react-icons/fa";

function DietPlanViewModal({ isOpen, onClose, selectedPlan, onEdit }) {
  const formatTime12hr = (timeStr) => {
    if (!timeStr) return "--:--";
    if (timeStr.includes("AM") || timeStr.includes("PM")) return timeStr;

    const [hoursStr, minutesStr] = timeStr.split(":");
    let hours = parseInt(hoursStr, 10);
    const minutes = minutesStr ? minutesStr.substring(0, 2) : "00";
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    return `${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-3xl h-[90vh] rounded-xl shadow-xl flex flex-col overflow-hidden animate-modalOpen p-3">
        <div className="flex items-center justify-between px-5 bg-white shrink-0">
          <div className="flex items-center gap-3">
            <label className="text-base font-semibold text-[#164463]">
              Diet Chart Details
            </label>
            <button
              onClick={onEdit}
              className="p-1.5 text-white  rounded-lg transition-colors flex items-center gap-1 text-sm font-medium"
            >
              <FaEdit size={14} />
              Edit
            </button>
          </div>

          <label
            onClick={onClose}
            className="text-2xl text-gray-500 hover:text-black cursor-pointer"
          >
            ×
          </label>
        </div>
        <div className="flex-1 overflow-y-auto scrollHide p-5 border rounded-md mt-2">
          <p className="text-base font-semibold text-brand-primaryColor">
            {selectedPlan?.chartTitle}
          </p>
          <div className="space-y-5 mt-4">
            {Object.entries(
              [...(selectedPlan?.dietPlanDetails || [])]
                .sort((a, b) => {
                  const dayA = parseInt(a.dayTitle.match(/\d+/)?.[0] || 0);
                  const dayB = parseInt(b.dayTitle.match(/\d+/)?.[0] || 0);
                  if (dayA !== dayB) return dayA - dayB;
                  return (a.sortOrder || 0) - (b.sortOrder || 0);
                })
                .reduce((acc, curr) => {
                  if (!acc[curr.dayTitle]) acc[curr.dayTitle] = [];
                  acc[curr.dayTitle].push(curr);
                  return acc;
                }, {})
            ).map(([dayTitle, meals], dayIndex) => (
              <div
                key={dayIndex}
                className="w-full bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden"
              >
                <div className="flex items-center justify-between px-5 py-2 bg-emerald-50 border-b border-emerald-100">
                  <h2 className="text-lg font-semibold text-emerald-900">
                    {dayTitle}
                  </h2>
                </div>

                <div className="overflow-x-auto">
                  <table className="w-full table-fixed text-sm border-collapse">
                    <colgroup>
                      <col className="w-[150px]" />
                      <col className="w-[220px]" />
                      <col />
                    </colgroup>
                    <thead>
                      <tr className="bg-gray-50 text-gray-600 border-b">
                        <th className="px-4 py-3 text-left font-semibold text-xs">
                          Time
                        </th>
                        <th className="px-4 py-3 text-left font-semibold text-xs">
                          Meal Type
                        </th>
                        <th className="px-4 py-3 text-center font-semibold text-xs">
                          Meal
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {meals.map((item, index) => (
                        <tr
                          key={index}
                          className="border-b last:border-b-0 hover:bg-emerald-50/40"
                        >
                          <td className="px-4 py-3 align-top text-left text-xs font-medium text-gray-800 whitespace-nowrap">
                            {formatTime12hr(item.mealTime)}
                          </td>
                          <td className="px-4 py-3 align-top text-left">
                            <span className="inline-flex rounded-full bg-gray-100 px-3 py-1 text-xs font-semibold text-gray-700 whitespace-nowrap">
                              {item.mealType}
                            </span>
                          </td>
                          <td className="px-4 py-3 align-top text-left text-xs font-semibold text-gray-700 leading-relaxed">
                            {item.meal}
                          </td>
                        </tr>
                      ))}
                      {meals[0]?.activity && (
                        <tr className="bg-amber-50/30">
                          <td className="px-4 py-3 font-bold text-amber-800 text-xs">
                            Activity
                          </td>
                          <td
                            colSpan="2"
                            className="px-4 py-3 text-gray-600 text-xs"
                          >
                            {meals[0].activity}
                          </td>
                        </tr>
                      )}
                      {meals[0]?.notes && (
                        <tr className="bg-blue-50/30">
                          <td className="px-4 py-3 font-bold text-blue-800 text-xs">
                            Notes
                          </td>
                          <td
                            colSpan="2"
                            className="px-4 py-3 text-gray-600 text-xs"
                          >
                            {meals[0].notes}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DietPlanViewModal;
